const shouldDownloadExcel = (status, items) => {
  return status && items.length > 0;
};

export default shouldDownloadExcel;
